import React, { useEffect, useState } from 'react';
import { paths } from 'src/paths';
import { Permissions, useScopeChecker } from 'src/rbac';
import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import loader from 'src/components/LoaderImg/loader.gif';
import { getSignatureAccessAction } from 'src/redux/actions/documentationAction';
import { Modal } from '@mui/material';
import SucessModal from 'src/components/sucess-modal';
import { logoutUser } from 'src/routes/AuthContext';

const   RedirectTab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userProfileResponse = useSelector((state: any) => state?.getTherapistProfileReducer);
  const has = useScopeChecker();

  const {
    dashboard,
    patients,
    dailySessionNotes,
    therapyPlanning,
    schedule,
    laborManagement,
    physicianDashboard,
    monthDayAlert,
    departmentComplianceAlerts
  } = paths;

  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    if (!userProfileResponse.getAdminProfile && !userProfileResponse.response) {
      //  setShowErrorModal(true);
      return;
    }
    switch (true) {
      case has(Permissions.PHYSICIAN_DASHBOARD):
        navigate(physicianDashboard);
        break;
      case has(Permissions.READ_BOARD_SELF):
        navigate(dashboard);
        break;
      case has(Permissions.READ_BOARD):
        navigate(departmentComplianceAlerts);
        break;
      case has(Permissions.READ_PATIENT):
        navigate(patients);
        break;
      case has(Permissions.READ_DAILY_NOTES):
        navigate(dailySessionNotes);
        break;
      case has(Permissions.READ_THERAPY_PLANNING):
        navigate(`${therapyPlanning.index}${therapyPlanning.details}`);
        break;
      case has(Permissions.READ_DAILY_TASK):
        navigate(schedule.therapistSchedule);
        break;
      case has(Permissions.READ_AVAILABILITY):
        navigate(laborManagement.index);
        break;
      case has(Permissions.READ_MONTH_END_ALERT):
        navigate(monthDayAlert);
        break;
      default:
        setShowErrorModal(true);
        break;
    }
  }, [userProfileResponse, has]);

  const redirectToLoginPage = () => {
    logoutUser();
  };

  return (
    <>
      <img
        src={loader}
        alt="loading..."
        style={{ margin: 'auto', display: 'block' }}
      />

      <Modal open={showErrorModal}>
        <SucessModal
          title="Error"
          message={'Something went wrong! Please try again'}
          close={redirectToLoginPage}
          isSucess={false}
        />
      </Modal>
    </>
  );
};

export default RedirectTab;
